<script setup lang="ts">
import BottomSheet from './BottomSheet.vue'
import ChargemapModal from './ChargemapModal.vue'
import { onMounted, onUnmounted, ref } from 'vue'

defineProps({
    visible: {
        type: Boolean,
        default: false
    }
})

defineEmits(['close'])

const isDesktop = ref(true)

onMounted(() => {
    if (import.meta.client) {
        isDesktop.value = window.innerWidth >= 768
    }

    // Use this workaround as useBreakpoints is not ssr-compatible
    window.addEventListener('resize', () => {
        if (import.meta.client) {
            isDesktop.value = window.innerWidth >= 768
        }
    })
})

onUnmounted(() => {
    window.removeEventListener('resize', () => {
        isDesktop.value = window.innerWidth >= 768
    })
})
</script>

<template>
    <ChargemapModal
        v-if="visible && isDesktop"
        class="transition-all duration-300 ease-in-out"
        :class="[
            visible && isDesktop
                ? 'opacity-100 pointer-events-auto'
                : 'opacity-0 pointer-events-none'
        ]"
        size="sm"
        show-x
        clear-x
        @clickedOutside="$emit('close')"
        @updateIsVisible="$emit('close')"
    >
        <slot />
    </ChargemapModal>

    <BottomSheet
        :visible="visible && !isDesktop"
        show-close-button
        :default-sheet-height="550"
        @updateVisible="$emit('close')"
    >
        <slot />
    </BottomSheet>
</template>
